module.exports = __webpack_public_path__ + "static/media/caravan-alt.f6ecd13d.svg";